import React from 'react';

import cn from 'classnames';
import Image from 'next/legacy/image';
import Link from 'next/link'

import { APP_ANDROID_PATH, APP_IOS_PATH } from '@constants/paths';
import { I18n } from '@utils/index';

import styles from './index.module.less';

export const Download = () => {
  const downloadData = [
    {
      url: APP_IOS_PATH,
      className: styles.btn1,
      channel: 'App Store'
    },
    {
      url: APP_ANDROID_PATH,
      className: styles.btn2,
      channel: 'Google Play'
    }
  ]
  return (
    <div className={styles.container}>
      <div className={styles.scanImg}>
          <Image
            src={require('@images/login/qrcode.webp')}
            layout="fixed"
            width={100}
            height={100}
            alt=''
          />
        </div>
        <div className={styles.btnWrapper}>
          {
            downloadData.map((data) => {
              const { url, className, channel } = data;
              return (
                <Link legacyBehavior href={url} key={channel}>
                  <a target="_blank">
                    <div className={cn(styles.btn, className)}>
                      <div>
                        <div className={cn(styles.desc, 'DINPro')}>{I18n.t('mFjPk078')}</div>
                        <div className={cn(styles.name, 'DINPro-Bold')}>{channel}</div>
                      </div>
                    </div>
                  </a>
                </Link>
              );
            })
          }
        </div>
    </div>
  );
};
